export enum OutputDesignation {
	ADVISOR_PORTFOLIO = 'Advisor Portfolio',
	MODEL = 'Model',
	ALTERNATE = 'Alternate',
	BENCHMARK = 'Benchmark',
	USER_PORTFOLIO = 'User Portfolio',
	BPAS_PORTFOLIO = 'Bpas Portfolio',
	CLIENT_PORTFOLIO = 'Client Portfolio',
	GLOBAL_COMPOSITE_BENCHMARK = 'Global Composite Benchmark'
}

export enum PortfolioType {
	USER = 'USER_PORTFOLIO',  // should only be used for subtype
	THIRD_PARTY = 'THIRD_PARTY',
	EXTERNAL = 'EXTERNAL_PORTFOLIO',
	MODEL = 'MODEL_PORTFOLIO',
	ASSET_CLASS = 'ASSET_CLASS',
	PORTFOLIO = 'PORTFOLIO' // should be used for portfolio type
}

export enum PortfolioEditorMode {
	EDIT = 'EDIT',
	NEW = 'NEW',
	ADD_NEW_TO_COMPARE = 'ADD_NEW_TO_COMPARE',
	VIEW = 'VIEW',
	BLEND = 'BLEND',
	CLONE = 'CLONE',
	CONTINUE = 'CONTINUE',
	DEFAULT = '',
	DELETE = 'DELETE',
	CANCEL = 'CANCEL'
}

// NOTE: if any new PDF category is added, update PDF_VIEW_CATEGORIES array in DisplayDataFactoryService
export enum ViewCategory {
	// 360 Views
	FA_PLUS = 'FA Plus',
	FA_SELF_SERVICE = 'FA Self Service',
	PROPOSAL = 'Proposal',

	// PDF
	PROPOSAL_PDF = 'PROPOSAL PDF',
	CLIENT_PDF = 'CLIENT PDF',
	ADVISOR_PDF = 'ADVISOR PDF',
	FA_PLUS_PDF = 'FA Plus PDF',
	FA_SELF_SERVICE_PDF = 'FA Self Service PDF',
	IRETIRE_ACCUM_PDF = 'Iretire Accum PDF',
	IRETIRE_DECUM_PDF = 'Iretire Decum PDF',

	// Other apps
	SCENARIO_TESTER = 'Scenario Tester',
	TAX_ESTIMATOR = 'Tax Estimator',
	MODELS_BROWSE = 'Models Browse',
	IRETIRE_ACCUM = 'Iretire Accum',
	IRETIRE_DECUM = 'Iretire Decum',

	//Models Experience Views
	MODELS_EXPERIENCE = 'Models Experience',
	MODELS_EXPERIENCE_PUBLIC = 'Models Experience Public'
}

export enum PdfCustomisationMode {
	SNAPSHOT = 'SNAPSHOT'
}

export enum Partner {
	ENVESTNET = 'envestnet'
}

export enum HoldingType {
	MANAGED_MODEL = 'MANAGED_MODEL',
	SMA = 'SMA',
	APM = 'APM_SLEEVE',
	SECURITY = 'SECURITY',
	ASSET_CLASS = 'ASSET_CLASS'
}

export enum VisibilityType {
	PUBLIC_VIEW = 'Visible in public app',
	LOGGED_IN_VIEW = 'Visible in logged in app'
}
